import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../../Auth/AuthStore';
import { Chart } from 'primereact/chart';
import IconButton from '@mui/material/IconButton';
import Backspace from '@mui/icons-material/ArrowBack';
//import './report.css';

export class ProfitByMonthReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            sales: [],
            sale: '',
            resultId: '',
            isDetailReportLoaded: false
        };

        this.loadReport = this.loadReport.bind(this);
        this.loadDetailReport = this.loadDetailReport.bind(this);
        this.onGraphClick = this.onGraphClick.bind(this);
    }

    componentDidMount() {
        this.loadReport();
    }

    loadReport() {
        var scope = this;
        scope.setState({ loading: true });

        var token = localStorage.getItem("token");

        fetch('api/Sale/GetMonthProfit', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                scope.setState({ loading: false });
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ sales: result, loading: false, isDetailReportLoaded: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    loadDetailReport() {
        var scope = this;
        scope.setState({ loading: true });

        var token = localStorage.getItem("token");

        fetch('api/Sale/GetMonthSaleProfit?resultId=' + this.state.resultId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                scope.setState({ loading: false });
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    result.forEach(r => r.color = scope.getRandomColor())
                    scope.setState({ sales: result, loading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    convertData(sales) {
        var data = {
            labels: [],
            datasets: [
                {
                    backgroundColor: [],
                    hoverBackgroundColor: [],
                    data: [],
                }
            ]
        };

        data.labels = sales.map(r => r.name);
        data.datasets[0].data = sales.map(r => r.profit);
        data.datasets[0].backgroundColor = sales.map(r => r.color);
        data.datasets[0].hoverBackgroundColor = sales.map(r => r.color);

        return data;
    }

    onGraphClick(arg1, elements) {
        !this.state.isDetailReportLoaded && this.setState({ resultId: this.state.sales[elements[0]._index].key, isDetailReportLoaded: true }, this.loadDetailReport);
    }

    getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    render() {
        var scope = this;
        const options = {
            onClick: this.onGraphClick,
            tooltips: {
                callbacks: {
                    label: function (tooltipItem) {
                        var sale = scope.state.sales[tooltipItem.index];
                        return sale.name + ' ' + sale.profit.toLocaleString('ru-RU', { style: 'currency', currency: 'RUR' });
                    }
                }
            },
        }

        return (
            <div>
                <h3>Прибыль за последний месяц</h3>
                {this.state.isDetailReportLoaded && <IconButton onClick={() => this.loadReport()} size="large">
                    <Backspace/>
                </IconButton>}
                {this.state.loading && <div className="block-progress-mask"><CircularProgress color="inherit" /></div>}
                {!this.state.loading && <Chart type="pie" data={this.convertData(this.state.sales)} options={options}  />}
            </div>
        );
    }
}